import { Injectable } from '@angular/core';
import { HttpInterceptor } from '../common/services/httpInterceptor.service';
import { ConfigService } from '../common/services/config.service';
import { Observable } from 'rxjs/internal/Observable';
import { CommonConstants } from '../common/utilities/commonConstants';
import { CookieHandlerService } from '../common/services/cookieHandler.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
    providedIn: 'root'
})
export class PricingService {
    constructor(
        private _httpInterceptor: HttpInterceptor,
        private _http: HttpClient,
        private _cookieHandler: CookieHandlerService) { }

    public validateConsentPricing(consentData: any, appId:string, consentRef:string): Observable<any> {
        let url = format(ConfigService.getInstance().getConfigObject().APIURL.consentValidation,appId,consentRef);
        const options = { headers: this.getHeaders1() };
        return this._httpInterceptor.Put(url, consentData, options);
    }

    public validateConsentPricingData(consentAuthToken: any, appId: string): Observable<any> {
        // tslint:disable-next-line:max-line-length
        const url = format(ConfigService.getInstance().getConfigObject().APIURL.consentPricingValidation + '?consentToken=' + consentAuthToken, appId);
        const options = { headers: this.getHeaders1() };
        return this._httpInterceptor.Get(url, options);
    }

    private getHeaders1 = (): HttpHeaders => {
        const ath = this._cookieHandler.GetCookie(CommonConstants.CookieKeys.AuthtokenUI);
        const headerObj: HttpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            'authtoken': this._cookieHandler.GetCookie(CommonConstants.CookieKeys.AuthtokenUI),
        });
        return headerObj;
    }

    public securedCookie(): Observable<any> {
        const reqPayload = {
            productCode: CommonConstants.ProductInfo.UnsecuredLoan.productCode
        };
        return this._httpInterceptor.Post(ConfigService.getInstance().getConfigObject().APIURL.securedCookie, reqPayload);
    }

    private getHeaders = (authtoken): HttpHeaders => {
        const headerObj: HttpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            'cmptcorrid': '',
            'authtoken': authtoken,
            'guardtoken': this._cookieHandler.GetCookie(CommonConstants.CookieKeys.GuardToken),
        });
        return headerObj;
    }
    public validatePricingApproval(applicationId: any, authtoken:any, data:any, actionRequired:any): Observable<any> {
        const options = { headers: this.getHeaders(authtoken) };
        let url = format(ConfigService.getInstance().getConfigObject().APIURL.pricingApprovalValidation,applicationId,actionRequired);
        return this._http.post(url, data, options);
    }
    public getAuthCodeForPricingApproval(data:any): Observable<any> {
        let url = format(ConfigService.getInstance().getConfigObject().APIURL.getAuthCodeForPricingApproval,data.userKey,data.authType);
        return this._httpInterceptor.Get(url);
    }

    public validateAuthCode(data:any): Observable<any> {
        let url = format(ConfigService.getInstance().getConfigObject().APIURL.validateAuthCode);
        return this._httpInterceptor.Post(url, data);
    }

    public generateServiceToken(data:any): Observable<any> {
        let url = format(ConfigService.getInstance().getConfigObject().APIURL.generateServiceToken);
        return this._httpInterceptor.Post(url, data);
    }
    
}
